function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}    

docReady(function() {
  $('br').attr("aria-hidden","true");
  $('hr').attr("aria-hidden","true");

  // expand header menu on hover
  $('[id^="Details-HeaderMenu-"]').hover(
    function () {      
      $(this).attr('open', '');
    },
    function () {      
      $(this).removeAttr('open');
    }
  );

  // Close all open details on Escape key press
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      $('[id^="Details-HeaderMenu-"]').removeAttr('open');      
    }
  });

  // Remove 'noscript' tags
  $('noscript').remove();
  
});
